import React, { Component } from 'react';

import { HIDDEN_CATEGORIES } from 'constants/qualityRequirements';
import QualityRequirementComponent from './QualityRequirementComponent';
import { Props } from './types';

export default class QualityRequirementContainer extends Component<Props> {
  static displayName = 'QualityRequirementContainer';
  isExcluded = () => {
    const { data: { category } } = this.props;
    return HIDDEN_CATEGORIES.indexOf(category) >= 0;
  };

  render = () => {
    if (this.isExcluded()) {
      return null;
    }

    return <QualityRequirementComponent {...this.props} />;
  }
}
